import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './load.module.scss'

const LoadItem = (props) => {
  const { className, width, height, margin, children } = props

  const loadItemClass = classNames(styles.loadItem, className)

  const loadContentStyles = {
    padding: margin
  }

  const loadItemStyles = {
    width: width || 'auto',
    height: height || 'auto'
  }

  return (
    <div style={loadContentStyles}>
      <div style={loadItemStyles} className={loadItemClass}>
        {children}
      </div>
    </div>
  )
}

LoadItem.defaultProps = {
  children: null,
  className: null,
  width: null,
  height: null,
  margin: null
}

LoadItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string
}

export default LoadItem
